<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('apiaries.title') }}</h1>
      <apiary-list></apiary-list>
    </b-container>
  </div>
</template>

<script>
import ApiaryList from '../components/ApiaryList'
export default {
  name: 'Apiaries',
  components: { ApiaryList }
}
</script>

<style scoped>

</style>
